<template>
  <component :is="layoutComponent">
    <RouterView />
  </component>
  <ProductOverview :product="modalState.product" />
</template>

<script setup>
import { RouterView, useRoute } from 'vue-router'
import { reactive, provide, computed } from 'vue'
import ProductOverview from '@/components/ProductCategory/ProductOverview.vue'

const modalState = reactive({
  product: {},
  isVisible: false,
})

const route = useRoute();
const layoutComponent = computed(() => route.meta.layoutComponent);

const showModal = (product) => {
  modalState.product = product;
  modalState.isVisible = true;
};

const closeModal = () => {
  modalState.isVisible = false;
};

// Provide modal visibility and control globally
provide('modalState', modalState);
provide('closeModal', closeModal);
provide('showModal', showModal);
</script>
